export class SavedPropertyDocumentContainer{

  savedId: string;
  documentEntryDate = new Map();

  constructor(savedId: string, documentEntryDate: Map<string,string>) {
    this.savedId = savedId;
    this.documentEntryDate = documentEntryDate;
  }

  toJSON(){
    var object = { };
    for (let [key, value] of this.documentEntryDate) object[key] = value;

    return{
      savedId: this.savedId,
      documentEntryDate: object
    }
  }


}
